export const DriverSettingsDefault = {
  dhtLimits: {
    limitTripInSec: 11,
    limitDayInSec: 11,
    limitWeekInSec: 60,
    limitMonthInSec: 192,
  },
  avatarMaxSize: 250 * 1014, // 100 KB
};
